module.exports = __webpack_public_path__ + "img/align_left.597c02fe.svg";